const authUrl: string = import.meta.env.VITE_AUTH_URL;

export const ApiEnum = {
    LOGOUT: authUrl + "/apiV2/oauth/logout",
};
